"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject;

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HEADER_SEARCH_MIN_LENGTH = exports.HEADER_SEARCH_LIMIT = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importStar(require("react"));

var Mobile_1 = __importDefault(require("./FullStructuredHeader/Mobile"));

var Desktop_1 = __importDefault(require("./FullStructuredHeader/Desktop"));

var Constants_1 = require("../common/Constants");

var CookieBanner_1 = __importDefault(require("./CookieBanner"));

var SimpleHeader_1 = __importDefault(require("./SimpleHeader"));

var styled_1 = __importDefault(require("@emotion/styled"));

var frontend_e_commerce_1 = require("@ryerson/frontend.e-commerce");

var MergeCartModal_1 = __importDefault(require("../MergeCartModal/MergeCartModal"));

var frontend_layout_1 = require("@ryerson/frontend.layout");

var HeaderContainer = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t.simple-header {\n\t\tdisplay: none;\n\t}\n\n\t@media print {\n\t\t.header-desktop {\n\t\t\tdisplay: none;\n\t\t}\n\t\t.header-mobile {\n\t\t\tdisplay: none;\n\t\t}\n\t\t.simple-header {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n"])));
exports.HEADER_SEARCH_LIMIT = 3;
exports.HEADER_SEARCH_MIN_LENGTH = 3;

var FullStructuredHeader = function FullStructuredHeader(_ref) {
  var headerData = _ref.headerData,
      _ref$storeDirectory = _ref.storeDirectory,
      storeDirectory = _ref$storeDirectory === void 0 ? Constants_1.STORE : _ref$storeDirectory,
      companyName = _ref.companyName,
      locationData = _ref.locationData;
  var contentElementStyle = (0, react_1.useRef)(""); // stores the current style on container

  var isSticky = (0, react_1.useRef)(false);

  var _ref2 = (0, frontend_e_commerce_1.useEcommerce)(),
      numberOfItems = _ref2.numberOfItems,
      showMergeCartModal = _ref2.showMergeCartModal,
      setShowMergeCartModal = _ref2.setShowMergeCartModal;

  react_1.default.useEffect(function () {
    sessionStorage.removeItem("isSticky");
  }, []);
  return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {
    children: (0, jsx_runtime_1.jsxs)(HeaderContainer, {
      children: [(0, jsx_runtime_1.jsx)(SimpleHeader_1.default, {
        storeDirectory: storeDirectory,
        companyName: companyName,
        renderMergeCartModal: false
      }), (0, jsx_runtime_1.jsx)(CookieBanner_1.default, {}), (0, jsx_runtime_1.jsx)(MergeCartModal_1.default, {
        numberOfItems: numberOfItems,
        showMergeCartModal: showMergeCartModal,
        setShowMergeCartModal: setShowMergeCartModal
      }), (0, jsx_runtime_1.jsx)(frontend_layout_1.Media, {
        lessThan: "lg",
        children: (0, jsx_runtime_1.jsx)(Mobile_1.default, {
          headerData: headerData,
          isSticky: isSticky,
          locationData: locationData,
          contentElementStyle: contentElementStyle,
          storeDirectory: storeDirectory,
          companyName: companyName
        })
      }), (0, jsx_runtime_1.jsx)(frontend_layout_1.Media, {
        greaterThanOrEqual: "lg",
        children: (0, jsx_runtime_1.jsx)(Desktop_1.default, {
          headerData: headerData,
          isSticky: isSticky,
          locationData: locationData,
          contentElementStyle: contentElementStyle,
          storeDirectory: storeDirectory,
          companyName: companyName
        })
      })]
    })
  });
};

exports.default = FullStructuredHeader;